// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const yanma: PokeData = {
  "id": 193,
  "name": "yanma",
  "height": 12,
  "weight": 380,
  "base_experience": 78,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "wing-attack",
    "tackle",
    "supersonic",
    "sonic-boom",
    "string-shot",
    "hypnosis",
    "quick-attack",
    "screech",
    "double-team",
    "swift",
    "foresight",
    "detect",
    "pursuit",
    "ancient-power",
    "uproar",
    "air-cutter",
    "silver-wind",
    "aerial-ace",
    "u-turn",
    "air-slash",
    "bug-buzz",
    "bug-bite"
  ],
  "moves": [
    "gust",
    "tackle",
    "supersonic",
    "string-shot",
    "quick-attack",
    "pursuit",
    "ancient-power",
    "aerial-ace",
    "air-slash",
    "bug-buzz",
    "bug-bite",
    "sticky-web",
    "infest"
  ],
  "evolution_chain": {
    "id": 95,
    "item": null,
    "species": [
      {
        "name": "yanma",
        "order": 223,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "yanmega",
        "order": 224,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 193,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "ancient-power"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 95,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
